// import { useNavigate } from "react-router-dom";
import LayoutMain from "../../shared/layouts/LayoutMain/LayoutMain";

const Home = () => {

  // const navigate = useNavigate();


  return (
    <LayoutMain idPage="Home">
      <div className="title-options bc-margin-top-3 bc-card-rounded">
        <div className="bc-row">
          <div className="bc-col-6">
            <h2>Bienvenidos a sistema de planeación</h2>
          </div>
        </div>
        <h4>
          Sistema de recoleccion de prioridades de estrategias de mercadeo
        </h4>
        <p>
          <strong>Planeación</strong> Busca generar el orden de las estrategias como deben i
        </p>
      </div>
      <div style={{margin: 10}}>
      <h5>¿Que tipo de estrategia vas a revisar?</h5>
      </div>
    </LayoutMain>
  );
};

export default Home;
